<template>
    <article class="discovery-card" :class="`discovery-card--${content.tone}`">
        <div class="discovery-card__copy">
            <h3>{{ copy[0] }}</h3>
            <p>{{ copy[1] }}</p>
        </div>
        <DiscoveryIllustration :scene="content.scene" />
        <div class="discovery-card__footer">
            <v-btn outlined rounded small color="primary" :to="sectionName ? { name: sectionName } : undefined" :loading="loading" :disabled="disabled" :aria-label="actionLabel || copy[2]" @click="$emit('choose')">
                {{ copy[2] }}
                <v-icon small right>mdi-arrow-right</v-icon>
            </v-btn>
            <slot name="secondary-action" />
        </div>
    </article>
</template>

<script>
import DiscoveryIllustration from './discovery-illustration.vue';
import { discoveryContent } from '@/utils/home-discovery';

export default {
    name: 'HomeDiscoveryCard',
    components: { DiscoveryIllustration },
    props: {
        sectionName: { type: String, default: null },
        illustration: { type: Object, default: null },
        actionLabel: { type: String, default: '' },
        loading: Boolean,
        disabled: Boolean,
        language: { type: String, default: 'fr' },
    },
    computed: {
        content() { return this.illustration || discoveryContent[this.sectionName]; },
        copy() { return this.content[this.language === 'fr' ? 'fr' : 'en']; },
    },
};
</script>

<style scoped lang="scss">
.discovery-card {
    --art-soft: #efebff;
    --art-accent: #8772d3;
    --art-deep: #48308a;
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    overflow: hidden;
    background: #fff;
    border: 1px solid #e9e5f2;
    border-radius: 20px;
    box-shadow: 0 3px 6px rgba(30, 24, 53, .035);
    transition: box-shadow .25s ease, border-color .25s ease;
    &--mint { --art-soft: #e7f4ed; --art-accent: #7daf9b; --art-deep: #276450; }
    &--peach { --art-soft: #fff0e4; --art-accent: #d6a077; --art-deep: #8d542c; }
    &:hover, &:focus-within { border-color: #d1c9e3; box-shadow: 0 8px 24px rgba(30, 24, 53, .07); }
}
.discovery-card__copy {
    padding: 22px 22px 0;
    z-index: 1;
    h3 { margin: 0 0 8px; font-size: 17px; line-height: 1.35; font-weight: 600; color: #252333; }
    p { margin: 0; max-width: 42ch; font-size: 13px; line-height: 1.6; color: #686373; }
}
.discovery-card__footer {
    padding: 0 22px 20px;
    z-index: 1;
    .v-btn { height: auto; min-height: 34px; padding: 8px 14px; letter-spacing: normal; text-transform: none; background: #fff; }
    ::v-deep .v-btn__content { white-space: normal; text-align: left; }
}
@media (prefers-reduced-motion: reduce) { .discovery-card { transition: none; } }
</style>
